/* istanbul ignore file */
export * from './CompactProduct';
